module.exports = {
  "zones": {
    "Asia/Dili": ["z", {
      "wallclock": 969148800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": 969120000000,
      "save": 0
    }, {
      "wallclock": 199929600000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": 199897200000,
      "save": 0
    }, {
      "wallclock": -879123600000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -879152400000,
      "save": 0
    }, {
      "wallclock": -1830384000000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -1830414140000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 30140000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};